/* eslint-disable */
import moment from "moment";
import 'moment/locale/ru';
import imageProxy from '@/js/common/Domain/Service/imageProxy';

import '@/js/common/plugins/flipclock/flipclock.min';

import directionsTemplate from './directionsTemplate.html';
import restTypesTemplate from './restTypes.html';
import DirectionsRepository from "@/js/common/Domain/Repository/Directions";
import RestTypesRepository from "@/js/common/Domain/Repository/RestTypes";

var directionsLimit = 9;

var DirectionsView = Backbone.Epoxy.View.extend({
	el:'<li></li>',
	computeds:{
		formatedPrice:{
			deps: ['price'],
			get: function(price){
				return price?price.formatNumber():0;
			}
		}
	},
	events: {
		'click a': 'directionClick'
	},
	directionClick: function(e){
		e.preventDefault();
		var $link = $(e.currentTarget);
		window.location = $link.attr('href');
		return false;
	},
	initialize:function(options) {
		var jsonData = this.model.toJSON({computeds:true});
		this.$el.html(directionsTemplate({
			...jsonData,
			imageProxy,
		}));
	}
});

var RestTypesViewModel =  Backbone.Epoxy.Model.extend({
	defaults: {
		active:false
	}
});

var RestTypesView = Backbone.Epoxy.View.extend({
	el:'<li data-bind="event:[\'click\', \'toggleRestTypeFilter\'], classes:{active:active}"></li>',
	viewModel: null,
	initialize:function(options) {
		this.collectionView = options.collectionView;

		this.initModels();
		this.render();
	},
	initModels:function() {
		this.viewModel = new RestTypesViewModel();
		this.collectionView.model.on('change:selectedRestType', $.proxy(this.restTypeFilterChanged, this));
	},
	render: function() {
		var jsonData = this.model.toJSON({computeds:true});
			jsonData['count'] = !_.isEmpty(this.collectionView.model.get('restTypesCount')) ? this.collectionView.model.get('restTypesCount')[jsonData.id] : 0;
		this.$el.html(restTypesTemplate(jsonData));

		if(!jsonData['count'] > 0) {
			this.$el.hide();
		}

	},
	restTypeFilterChanged:function() {
		var currentRestType = this.collectionView.model.get('selectedRestType');

		if(currentRestType === this.model) {
			this.viewModel.set('active', true);
		} else {
			this.viewModel.set('active', false);
		}
	},
	toggleRestTypeFilter: function() {
		var currentRestType = this.collectionView.model.get('selectedRestType');
		if(currentRestType === this.model) {
			this.collectionView.model.set('selectedRestType', null);
		} else {
			this.collectionView.model.set('selectedRestType', this.model);
		}
	}
});

var NewYearIndexModel = Backbone.Epoxy.Model.extend({
		defaults: {
			selectedRestType:null,
			showAll:false,
			directions: null
		},
		computeds:{
			filteredDirections:function() {
				var allDirections = this.get('directions'),
					selectedResortType =  this.get('selectedRestType'),
					filteredDirections = [];

				if(selectedResortType !== null) {
					allDirections.each(function(direction) {
						var restTypes = direction.get('restTypes');

						if(!_.isEmpty(restTypes) && restTypes.indexOf(selectedResortType) !== -1) {
							filteredDirections.push(direction);
						}
					});
					return new DirectionsRepository(filteredDirections);
				} else {
					return allDirections;
				}
			},
			filteredDirectionsWithShowAll: function() {
				var filteredDirections = this.get('filteredDirections'),

					showAll = this.get('showAll');

				if(!_.isEmpty(filteredDirections)) {
					if(!showAll) {
						return new DirectionsRepository(filteredDirections.models.slice(0, directionsLimit));
					} else {
						return new DirectionsRepository(filteredDirections.models);
					}
				} else {
					return [];
				}

			},
			selectedRestTypeName: function() {
				var selectedRestType = this.get('selectedRestType');

				return selectedRestType ? selectedRestType.get('name') : 'Популярные направления на Новый Год';
			},
			showMoreButtonVisible: function() {
				var filteredDirections = this.get('filteredDirections');

				if(!_.isEmpty(filteredDirections) && filteredDirections.length > directionsLimit) {
					return true;
				} else {
					return false;
				}
			},
			restTypesCount:function() {
				var directions = this.get('directions'),
					allRestTypes = [];

				if(directions && directions.length) {

					directions.each(function(direction) {
						var restTypes = direction.get('restTypes');

						if(!_.isEmpty(restTypes)) {
							allRestTypes = allRestTypes.concat(restTypes.pluck('id'));
						}
					});
					return _.countBy(allRestTypes, function(hotelTypeId){
						return hotelTypeId;
					});

				} else {
					return null;
				}

			}
		},
		selectedRestTypeChanged:function() {
			this.set('showAll', false);
		},
		initialize:function() {
			this.on('change:selectedRestType', $.proxy(this.selectedRestTypeChanged, this));
		}
});

let NewYearIndexView = Backbone.Epoxy.View.extend({
	el:'.toursCity',
	model: new NewYearIndexModel(),
	collection:new DirectionsRepository(),
	itemView:DirectionsView,
	bindingSources: {
		restTypesCollection:new RestTypesRepository()
	},
	restTypesView:RestTypesView,
	updateCollection:function() {
		var self = this;

		this.collection.reset(this.model.get('filteredDirectionsWithShowAll').models);
		setTimeout(function() {
			self.initTooltips();
		},50);

	},
	initTooltips:function() {
		$(".cityPreview_label .icon").not('.added').addClass('added').tooltip({
			position: {
				// my: "center top",
				// at: "center bottom+10",
				using: function( position, feedback ) {
				  $( this ).css( position );
				  $( "<div>" )
					.addClass( "arrow" )
					.addClass( feedback.vertical )
					.addClass( feedback.horizontal )
					.appendTo( this );
				}
			  }
		});
	},
	initCountdown: function() {
		var today = moment();
		if (today.month() < 5) {
			$('.newYearcountDownEnd').show();
		} else {

			$('.newYearcountDown .clockTitle').show();
			$('.newYearcountDown .clock').show();

			let seconds = moment.duration(moment().endOf("year").diff(moment())).asSeconds();
			$('.clock').FlipClock(seconds, {
				clockFace: 'DailyCounter',
				countdown: true,
				language: 'ru',
				stop: function () {
					$('.newYearcountDown .clockTitle').fadeOut(1000);
					$('.newYearcountDown .clock').fadeOut(1000, function () {
						$('.newYearcountDownEnd').fadeIn();
					});
				}
			});
			if ($('.flip').length == 8) {
				$('.flip-clock-divider.days .flip-clock-label').css('left', 4);
			}
		}

	},
	initialize:function() {
		var self = this;

		this.model.set('directions', DirectionsRepository.repository);

		this.bindingSources.restTypesCollection.reset(RestTypesRepository.repository.models);

		this.updateCollection();
		this.initCountdown();
		this.model.on('change:filteredDirectionsWithShowAll', $.proxy(this.updateCollection, this));
	}
});

export default NewYearIndexView;